import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Aos from "aos";
import "aos/dist/aos.css";
import Popupform from "../pages/contact/popup_form";
import baseUrl from "../../baseUrl";

const Footer = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [jsonData, setJsonData] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991);
  const [isPageLoaded, setIsPageLoaded] = useState(false); // 👈 NEW STATE
  const [showFooter, setShowFooter] = useState(false); // 👈 NEW STATE


  // Handle responsive detection
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Detect when page is fully loaded
  useEffect(() => {
    const handlePageLoad = () => {
      setIsPageLoaded(true);
    };
    if (document.readyState === "complete") {
      setIsPageLoaded(true);
    } else {
      window.addEventListener("load", handlePageLoad);
    }
    return () => window.removeEventListener("load", handlePageLoad);
  }, []);

    // Delay showing footer after page load
  useEffect(() => {
    if (isPageLoaded) {
      const timer = setTimeout(() => setShowFooter(true), 3500); // 👈 1.5 sec delay
      return () => clearTimeout(timer);
    }
  }, [isPageLoaded]);

  // Scroll to top handler
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Modal controls
  const handleShow = useCallback(() => setShow(true), []);
  const handleClose = useCallback(() => setShow(false), []);

  // Fetch data once
  useEffect(() => {
    const fetchData = async () => {
      try {
        window.scrollTo(0, 0);
        const response = await fetch(`${baseUrl}/wp-json/wp/v2/pages/?slug=option`);
        const data = await response.json();
        setJsonData(data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };

    Aos.init({ duration: 1000, once: true });
    fetchData();
  }, []);

  // Toggle menu in mobile
  const toggleMenu = useCallback(
    (menuName) => setOpenMenu(openMenu === menuName ? null : menuName),
    [openMenu]
  );

  // 🧠 Wait until both data + page load are complete
  if (!jsonData || !isPageLoaded)
    return (
      <div className="avt_loader_wrap">
        <span className="avt_loader">
          <span className="avt_loader_inner"></span>
        </span>
      </div>
    );

  const { acf } = jsonData[0];
  const path = location.pathname;
  const showBookButton = ["/", "/about"].includes(path);

  return (
    <footer className="avt-footer-sec" style={{display: showFooter ? "block" : "none"}}>
      {/* Modal */}
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal heading</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <section className="avt-contact-sec avt-popup-contact-wrap avt-popup-contact-wrap avt-popup2-contact-wrap">
            <div className="container-fluid">
              <div className="avt-popup-form-wrap">
                <h2 className="avt-popup-form-heading-cls">
                  We Look Forward To Your Enquiry
                </h2>
                <Popupform />
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>

      {/* Footer content */}
      <div className="container">
        <div className="row text-center">
          <div className="col-lg-12">
            <div className="avt-footer-col">
              <div className="avt-footer-logo-wrap">
                <img
                  data-aos="fade-in"
                  src={acf.footer_image}
                  alt="Footer Logo"
                  loading="lazy"
                  className="aos-init aos-animate"
                />
                <div
                  className="footer-text"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <h2 dangerouslySetInnerHTML={{ __html: acf.footer_text }} />
                  <p>
                    A vibrant, energetic and collaborative team of professionals
                    committed to delivering value through innovative solutions
                  </p>
                </div>
              </div>

              <div className="avt-footer-btn-wrap text-center">
                {showBookButton ? (
                  <Link className="avt-btn" to="#" onClick={handleShow}>
                    <span>Book In a Time With Us</span>
                  </Link>
                ) : path === "/contact" ? null : (
                  <Link className="avt-btn avt-btn-page" to="/contact">
                    {/* <span>Send Enquiry</span> */}
                    <span>Book In A Time With Us</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="avt-footer-sections">
          {/* Section 1 */}
          <div className="avt-footer-section1 footer-section">
            <div className="footer-logo">
              <img src={acf.logo_image} alt="Avant Tech Logo" loading="lazy" class="aos-init aos-animate" data-aos="fade-in" />
            </div>
            <div className="footer-description">
              <p>
                A vibrant, energetic, collaborative team of multi-skilled web
                and mobile app development experts committed to delivering value
                through innovation for business.
              </p>
            </div>

            <ul className="social-section">
              {[
                { href: acf.facebook, img: "fb-icon-1.png" },
                { href: acf.insta, img: "insta-icon-1.png" },
                { href: acf.linkedin, img: "linkedion-icon-1.png" },
              ].map(({ href, img }, i) => (
                <li key={i}>
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    <img src={`assets/images/footer/${img}`} alt="" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div className="avt-footer-section2 footer-section">
            <h3
              onClick={() => !isDesktop && toggleMenu("quickLinks")}
              className={!isDesktop ? "collapsible-title" : ""}
            >
              Quick Links
            </h3>
            {(isDesktop || openMenu === "quickLinks") && (
              <ul>
                {[
                  { to: "/", label: "Home" },
                  { to: "/about", label: "About" },
                  { to: "/blog", label: "Blog" },
                  { to: "/contact", label: "Let's Connect" },
                  { to: "/terms-and-conditions", label: "Terms & Conditions" },
                  { to: "/sitemap", label: "Sitemap" },
                ].map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to} onClick={scrollToTop}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Services */}
          <div className="avt-footer-section3 footer-section">
            <h3
              onClick={() => !isDesktop && toggleMenu("services")}
              className={!isDesktop ? "collapsible-title" : ""}
            >
              Our Services
            </h3>
            {(isDesktop || openMenu === "services") && (
              <ul>
                {[
                  { to: "/web-development", label: "Web Development" },
                  {
                    to: "/mobile-app-development",
                    label: "Mobile App Development",
                  },
                  { to: "/ui-ux-design", label: "UI/UX Design" },
                  {
                    to: "/software-development",
                    label: "Software Development",
                  },
                  {
                    to: "/artificial-intelligence",
                    label: "Artificial Intelligence",
                  },
                ].map(({ to, label }) => (
                  <li key={to}>
                    <Link to={to} onClick={scrollToTop}>
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Contact & Social */}
          <div className="avt-footer-section4 footer-section">
            <h3>Contact Us</h3>
            <ul className="address-section">
              <li>
                <a href="tel:1300239212">
                  <img
                    src="assets/images/contact/v2/phone-icon.png"
                    alt="Phone"
                  />
                  1300 239 212
                </a>
              </li>
              <li>
                <a href="mailto:info@avanttech.com.au">
                  <img
                    src="assets/images/contact/v2/email-icon.png"
                    alt="Email"
                  />
                  info@avanttech.com.au
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div
          className="avt-footer-copytext"
         //dangerouslySetInnerHTML={{ __html: acf.footer_copy_text }}
        />
        @ 2026 Avant Tech. All right Reserved
      </div>
    </footer>
  );
};

export default Footer;
